module.exports = __webpack_public_path__ + "img/GM.5bbf7b74.svg";